<span [ngClass]="setClasses()" class="ax-checkbox" (click)="checkedChange($event)" [tabIndex]="tabIndex" (focus)="onFocus()" (blur)="onFocusLost()">
    <i *ngIf="isChecked" class="fa-light fa-check ax-checkbox__icon"></i>
</span>
